namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailAdmParametrGlobal extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GAdmParametrGlobalReadDto;
        private newRecord: boolean;
        private detailObj: DetailAdmParametrGlobalObj & GContent;
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;
        private uroven_cfg: number;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.element.addHelpContext("level:" + Gordic.Adm.WebControls.FunctionsAdmParametrGlobal.createContenxtHelpString(this.uroven_cfg))
            this.detailObj = $.extend(this, new DetailAdmParametrGlobalObj());
            this.detailObj.createBase({
                contentName: "detailAdmParametrGlobal",
                contentCaption: this.createContentCaption(),
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false) {
                tabs.push(this.detailObj.getParametryVsechnyUrovneTab());
                tabs.push(this.detailObj.getAuditPristupuTab());
            }
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false) {
                groups.push(this.detailObj.getParametryVsechnyUrovneGroup());
                groups.push(this.detailObj.getAuditPristupuGroup());
            }
            // Sidepanels
            var sidepanels: Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId[] = [];
            if (this.newRecord == false) {
                sidepanels.push(this.detailObj.getParametrInfoSidebar());
                sidepanels.push(this.detailObj.getPoznamky());
            }
            builder.withComponent<this>("DetailAdmParametrGlobal", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: sidepanels,
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
            this.detailObj.afterCreatingForm();
            
        }

        closing() {
            return this.detailObj.closeAction();
        }

        createContentCaption() {
            switch (this.uroven_cfg) {
                case 20:
                    return "jres:33000307";
                case 30:
                    return "jres:33000315"; //RC 33000315 : Parametr pro licenci
                case 35:
                    return "jres:33000316"; //RC 33000316 : Parametr pro st�edisko spis. uzl�
                case 38:
                    return "jres:33000317" //RC 33000317 : Parametr pro f�zi
                case 40:
                    return "jres:33000303";
                case 60:
                    return "jres:33000305"; 
                case 70:
                    return "jres:33000318"; //RC 33000318 : Parametr pro ext. syst�m
                default:
                    return "jres:33000288"; //RC 33000288 : Glob�ln� parametr
            }
        }
    }


    export class DetailAdmParametrGlobalObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GAdmParametrGlobalReadDto> {
        uroven_cfg: number;
        copy: boolean;
        allowCopy: boolean;
        private currentConfigValue: string;
        private currentParamInfo: Gordic.Adm.Interface.GGincparDto;
        private srv: GContent;
        private gridParametryVsechnyUrovne: JQuery<HTMLElement>;
        private configData: any[];

        private getSrv(): GContent {
            if (this.srv)
                return this.srv;
            this.srv = this.cnt.createServiceContent("Gordic.Adm.WebControls.DetailAdmParametrGlobal");
            return this.srv;
        }

        create() {
            this.currentConfigValue = "";
            if (this.data.config_long != null)
                this.data.config = this.data.config_long;
        }

        textPopis(): string | undefined | null {
            return this.data["param"]
        }

        setSxsDetail(): string {
            return this.data.uroven_cfg + "#" + this.data.param + "#" + this.data.subj_cfg + "#";
        }

        // Parametry pro v�echny �rovn�

        getParametryVsechnyUrovneTab(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-parametry-vsechny-urovne",
                    title: "jres:33000321", //RC 33000321 : Nastaven� parametr� pro v�echny �rovn�
                    opened: true,
                    locked: true,
                    group: { id: "_tab-parametry-vsechny-urovne" },
                    open: () => {
                        this.loadGridParametryVsechnyUrovne();
                    }
                },
                init: (tab) => { this.createGridParametryVsechnyUrovne(tab) },
            }
        }

        getParametryVsechnyUrovneGroup(): IGTabGroupOptions {
            return { id: "_tab-parametry-vsechny-urovne", caption: "jres:33000321" }
        }

        createGridParametryVsechnyUrovne(tab) {
            this.gridParametryVsechnyUrovne = $("<div>").appendTo(tab).gautofit({ resizersOnTab: false }).ggrid({
                columns: new Gordic.Data.GridFormat()
                    .addTextColumn({
                        name: "uroven_cfg_txt",
                        caption: "jres:33000322" //RC 33000322 : �rove�
                    })
                    .addTextColumn({
                        name: "subj_cfg_txt",
                        caption: "jres:33000323" //RC 33000323 : Nastaveno pro subjekt
                    })
                    .addTextColumn({
                        name: "config_txt",
                        caption: "jres:33000324", //RC 33000324 : Nastaven� hodnota
                    })
            })
        }

        loadGridParametryVsechnyUrovne() {
            this.cnt.beginOperation()
            Gordic.Isl.AdmParametrGlobal.listSettingsAllLevels({ filters: { param: this.data.param } }).getData().done((data) => {
                this.gridParametryVsechnyUrovne.ggrid("setData", data);
            }).always(() => { this.cnt.endOperation() })
        }

        // Na�ten� informac� o parametrech 

        getParametrInfoSidebar(): Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId {
            return {
                leaf: {
                    caption: "jres:33000359" //RC 33000359 : Informace o parametru
                },
                visible: true,
                width: 400,
                id: "parametrInfo",
                caption: "jres:33000359",
                side: "right",
                icon: "gi-nahled",
                open: (ev, obj) => {
                    this.loadParamInfo($(ev.target));
                }
            }
        }

        private loadParamInfo(panel: JQuery<HTMLElement>) {
            if (this.data.param) {
                panel.empty();
                Gordic.Isl.AdmParametrGlobal.readParamInfo({ filters: { param: this.data.param } }).getData().done((data) => {
                    var form = $("<div class='js-sml size-S'>").gform("createFrom", this.createParamInfoForm()).appendTo(panel);
                    form.findFields().gfield("model", "apply", data);
                })
            }
        }

        private createParamInfoForm(): Gordic.Forms.Form {
            var _this = this;
            return new Gordic.Forms.Form({ name: "form-param-info" })
                .addRow("jres:33000135").addField("gstaticfield", { name: "param_info.param_txt" })
                .addRow("jres:30011356").addField("gstaticfield", { name: "popis" })
                .addRow("jres:33000360").addField("gstaticfield", { //RC 33000360 : Typ parametru
                    name: "param_info",
                    modelValueTransform: {
                        apply: (value) => {
                            return this.zpusobZadaniHodnotyParametru(value) + this.typHodnotyParametru(value)
                        } 
                    }
                })
                .addRow("jres:33000361").addField("gstaticfield", { //RC 33000361 : Seznam hodnot
                    name: "config_data",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", _this.seznamHodnot(dto));
                                break;
                        }
                    }
                })
                .addRow("jres:33000363").addField("gstaticfield", { //RC 33000363 : V�choz� hodnota
                    name: "config_txt",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                var configtxt = "-";
                                if (dto.param_info.config != null && dto.param_info.config != undefined)
                                    configtxt = dto.param_info.config_txt;
                                $(this).gfield("setValue", configtxt);
                                break;
                        }
                    }
                })
                .addRow("jres:33000364").addField("gstaticfield", { //RC 33000364 : P�i�azen k modulu
                    name: "povolene_faze",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", _this.seznamFaze(dto));
                                break;
                        }
                    }
                })
                .addRow("jres:33000366").addField("gstaticfield", { //RC 33000366 : P��stupn� na �rovn�ch
                    name: "povolene_urovne",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", _this.seznamUrovne(dto));
                                break;
                        }
                    }
                }) 
        }

        private zpusobZadaniHodnotyParametru(parametr: Gordic.Adm.Interface.GGincparDto) {
            var zpusobZadaniParametru = "";
            switch (parametr.typ_par) {
                case 0:
                    zpusobZadaniParametru = "jres:33000293";
                    break;
                case 10:
                    zpusobZadaniParametru = "jres:33000294";
                    break;
                case 20:
                    zpusobZadaniParametru = "jres:33000295";
                    break;
            }
            return zpusobZadaniParametru + "<br />";
        }

        private typHodnotyParametru(parametr: Gordic.Adm.Interface.GGincparDto) {
            var typHodnoty = "";
            if (parametr.typ_par == 10 || parametr.typ_par == 20) {
                if (parametr.priz_multi == 1)
                    typHodnoty = "jres:33000297"
                else
                    typHodnoty = "jres:33000298"
            } else {
                if (parametr.priz_passwd == 1)
                    typHodnoty = "jres:33000290" //RC 33000290 : Hodnota nen� ve�ejn� (heslo)
                else if (parametr.priz_num == 1)
                    typHodnoty = "jres:33000291" //RC 33000291 : Pouze celo��seln� znaky
                else if (parametr.priz_num == 2)
                    typHodnoty = "jres:33000292" //RC 33000292 : Desetinn� ��slo
                else
                    typHodnoty = "jres:33000296" //RC 33000296 : Textov� hodnota
            }
            return typHodnoty;
        }

        private seznamHodnot(parametrInfo: Gordic.AdmIsl.Interface.GAdmParamertInfoDto): string {
            var html = "";
            if (parametrInfo) {
                if (parametrInfo.param_info?.typ_par == 10 || parametrInfo.param_info?.typ_par == 20) {
                    if (parametrInfo.config_data) {
                        html = "<ul>"
                        parametrInfo.config_data.configData?.forEach((item) => {
                            html += "<li>{0}<br /><span style='font-weight: normal;' >{1}</span></li>".format((item.config_txt) ? item.config_txt : "", (item.popis) ? item.popis : "");
                        })
                        html += "</ul>"
                    } else {
                        html = "-";
                    }
                } else {
                    html = "jres:33000362" //RC 33000362 : Hodnoty jsou voln� editov�ny u�ivatelem.
                }
            }
            return html;
        }

        private seznamFaze(parametrInfo: Gordic.AdmIsl.Interface.GAdmParamertInfoDto): string {
            var html = "";
            if (parametrInfo) {
                if (parametrInfo.param_info?.priz_glob == 1) {
                    html += "jres:33000365" //RC 33000365 : V�echny f�ze
                } else {
                    if (parametrInfo.povolene_faze) {
                        html = "<ul>";
                        parametrInfo.povolene_faze.forEach((item) => {
                            html += "<li>{0}</li>".format((item.faze) ? item.faze : "");
                        })
                        html += "</ul>"
                    } else {
                        html = "-";
                    }
                }
            }
            return html;
        }

        private seznamUrovne(parametrInfo: Gordic.AdmIsl.Interface.GAdmParamertInfoDto): string {
            var html = "-";
            if (parametrInfo) {
                if (parametrInfo.povolene_urovne) {
                    html = "<ul>"
                    parametrInfo.povolene_urovne.forEach((item) => {
                        html += "<li>{0}</li>".format((item.uroven_cfg_txt) ? item.uroven_cfg_txt : "")
                    })
                    html += "</ul>"
                }
            }
            return html;
        }

        saveData(data: Gordic.AdmIsl.Interface.GAdmParametrGlobalSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            if (data.param_info?.priz_long == 1)
                data.config_long = data.config;
            delete data.param_info;
            (this.cnt.isl.AdmParametrGlobal.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    if (output.result.errors.length > 0) {
                        if (output.result.errors[0].message.startsWith("DOTAZ")) {
                            var message = output.result.errors[0].message.replace("DOTAZ", "");
                            this.cnt.dialogs.confirmDangerous("jres:33000257", message).on("yes", () => {
                                // Nastav�m odpoved na ano
                                data.odpoved = 1;
                                // Zavol�m ulo�eni znovu
                                this.saveData(data, close);
                            })
                        } else {
                            this.checkErrors(output.result.errors)
                            this.pendingAction("actSave", false)
                        }
                    } 
                }
            }).catch((err) => {
                this.pendingAction("actSave", false)
                throw err;
            })
        }

        // P�et�en� metoda pro saveBase pro ulo�en� p��padn�ch dat z pol��ka password
        protected saveBase(close: boolean) {
            this.hideAllFlash();
            var form = this.cnt.findForms("{0}form".format(this.options.contentName))
            var novaData: any = {};
            if (form.gform("isValid")) {
                novaData.param_info = this.currentParamInfo;
                return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                    form.findFields().gfield("model", "collect", novaData, {});
                    this.convertValueDoSaveObject(novaData, close)
                })
            }
        }

        private convertValueDoSaveObject(novaData: any, close: boolean) {
            var saveData: Gordic.AdmIsl.Interface.GAdmParametrGlobalSaveDto = {};
            // Nastaven� configura�n�ch dat dat
            var errorValueMap = true;
            saveData.param_info = novaData.param_info;
            saveData.config = "";
            saveData.config_txt = "";
            saveData.uroven_cfg = this.uroven_cfg;
            if (this.uroven_cfg == 10)
                saveData.subj_cfg = "glob"
            else
                saveData.subj_cfg = novaData.subj_cfg;
            switch (saveData.param_info?.typ_par) {
                case 0:
                    if (saveData.param_info.priz_passwd == 1) {
                        if (novaData["zpusob_ulozeni_hesla"] != null && novaData["zpusob_ulozeni_hesla"] != undefined) {
                            saveData.zpusob_ulozeni_hesla = novaData["zpusob_ulozeni_hesla"];
                            switch (novaData["zpusob_ulozeni_hesla"]) {
                                case 0:
                                    if (novaData.password_value) {
                                        saveData.config = novaData.password_value;
                                        saveData.config_txt = "**********";
                                    }
                                    break;
                                case 10:
                                    saveData.config = "";
                                    saveData.config_txt = "**********";
                                    break;
                                case 20:
                                    if (novaData.password_map) {
                                        saveData.config = novaData.password_map;
                                        saveData.config_txt = "**********";
                                    } else {
                                        errorValueMap = false;
                                    }
                                    break;
                            }
                        }
                    } else {
                        if (novaData[this.currentConfigValue]) {
                            saveData.config = novaData[this.currentConfigValue].toString();
                            saveData.config_txt = novaData[this.currentConfigValue].toString();
                        }
                    }
                    break;
                case 10:
                case 20:
                    if (novaData[this.currentConfigValue]) {
                        saveData.config = novaData[this.currentConfigValue].config;
                        saveData.config_txt = novaData[this.currentConfigValue].config_txt;
                    }
                    break;
            }
            // Ostatn� data 
            saveData.aktivita = novaData.aktivita;
            saveData.param = novaData.param;
            if (errorValueMap == true) {
                this.getSrv().call("UpdateData", { novaData: saveData }).done((o) => {
                    if (o.param_info.priz_passwd == 1 && o.zpusob_ulozeni_hesla == 0) {
                        this.cnt.dialogs.confirmDangerous("jres:33000728", "jres:33000729").on("yes", () => { //RC 33000729 : Opravdu si p�ejete ulo�it nov� heslo do datab�ze?
                            this.saveData(o, close);
                        }) 
                    } else {
                        this.saveData(o, close);
                    }
                })
            } else {
                this.cnt.dialogs.error("jres:32000124", "jres:33000637") //RC 33000637 : Vypl�te pros�m mapovac� �et�zec.
            }
        }

        reloadData(filterObj: any, dataObj: any) {
            dataObj.allowCopy = this.allowCopy;
            this.openDetailOrModalWindow("Gordic.Adm.WebControls.DetailAdmParametrGlobal", filterObj, dataObj);
        }

        updateGrid(filter: any, grid: any): JQueryPromise<Gordic.Data.View<Gordic.Data.UnpackRow<any>>> {
            return this.cnt.isl.AdmParametrGlobal.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            if (this.uroven_cfg == 40 || this.uroven_cfg == 60 || this.uroven_cfg == 70 || this.uroven_cfg == 35)
                return "{0} ({1}) - {2}".format(this.options.contentCaption, (this.data.subj_cfg_txt && this.data.subj_cfg_txt) ? this.data.subj_cfg_txt : "", (this.data.param_info?.param_txt && this.data.param_info?.param_txt) ? this.data.param_info.param_txt : "")
            if (this.uroven_cfg == 20 || this.uroven_cfg == 30 || this.uroven_cfg == 38)
                return "{0} ({1}) - {2}".format(this.options.contentCaption, (this.data.subj_cfg && this.data.subj_cfg) ? this.data.subj_cfg : "", (this.data.param_info?.param_txt && this.data.param_info?.param_txt) ? this.data.param_info.param_txt : "")
            else
                return "{0} - {1}".format(this.options.contentCaption, (this.data.param_info && this.data.param_info.param_txt) ? this.data.param_info.param_txt : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                "actCopy*",
                /*"actTest*",*/
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" },
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actCopy: {
                    caption: "jres:33000669", //RC 33000669 : Kopie
                    icon: "gi-copy",
                    enabled: ((this.uroven_cfg != 10 && this.uroven_cfg != 20) || this.options.newRecord == false) && this.allowCopy == true,
                    run: (ev, ctx) => {
                        this.copyParam();
                    }
                }
            }
            //return {
            //    actTest: {
            //        caption: "Otestovat k�dov�n�",
            //        run: (ev, ctx) => {
            //            this.openTestForm();
            //        }
            //    },
            //    actOk: {
            //        caption: "OK",
            //        run: (ev, ctx) => {
            //            this.testOk(ev);
            //        }
            //    }
            //}
        }

        setEditMode(editMode: boolean) {
            this.cnt.actions.actCopy?.update({ enabled: false });
            if (this.currentConfigValue) {
                this.cnt.findFields(this.currentConfigValue).gfield((editMode == true) ? "enable" : "disable");
                if (this.currentConfigValue == "password_value") {
                    this.cnt.findFields("password_type").gfield((editMode == true) ? "enable" : "disable");
                    this.cnt.findFields("password_map").gfield((editMode == true) ? "enable" : "disable");
                }
            }
        }

        createForm() {
            var _this = this;
            // Prefab pro v�b�r subjektu
            this.createSubjectField();

            this.MakeSelectField("param", Gordic.Prefabs.Select.gincpar(), {
                dropdown: false,
                serverFilters: this.createServerFiltersParam(),
                model: "model.param=value.param",
                change: (ev, ctx) => {
                    this.configData = [];
                    if (ctx.value) {
                        if (!Array.isArray(ctx.value)) {
                            if (ctx.value.typ_par == 10 || ctx.value.typ_par == 20) {
                                this.cnt.isl.AdmParametrGlobal.listConfigData({ filters: { param: ctx.value.param } }).getData().done((obj) => {
                                    if (ctx.value && obj.configData) {
                                        if (!Array.isArray(ctx.value)) {
                                            this.configData = obj.configData;
                                            this.cnt.findFields(this.currentConfigValue).gfield("option", "data", obj.configData);
                                        }
                                    }
                                })
                            }
                            this.HideField("number_value");
                            this.HideField("decimal_value");
                            this.HideField("string_value");
                            this.HideField("password_value");
                            this.HideField("password_type");
                            this.HideField("seznam_value");
                            this.HideField("seznam_value_multi");
                            if (this.currentConfigValue) {
                                this.cnt.findFields(this.currentConfigValue).gfield("setValidators", [])
                                this.cnt.findFields(this.currentConfigValue).gfield("option", "flag", null);
                                this.cnt.findFields(this.currentConfigValue).gfield("disable");
                            }
                            var openValue = "";  // Zobrazen� spr�vn�ho pole
                            var typeValue = "";  // Typ vstupn� hodnoty
                            var editValue = "";  // Voln� nebo pevn� hodnota z ��seln�ku
                            switch (ctx.value.typ_par) {
                                case 0:
                                    editValue = "jres:33000293" //RC 33000293 : Voln� editovateln� hodnota
                                    if (ctx.value.priz_passwd == 1) {
                                        typeValue = "jres:33000290" //RC 33000290 : Hodnota nen� ve�ejn� (heslo)
                                        openValue = "password_value"
                                    } else if (ctx.value.priz_num == 1) {
                                        typeValue = "jres:33000291" //RC 33000291 : Pouze celo��seln� znaky
                                        openValue = "number_value"
                                    } else if (ctx.value.priz_num == 2) {
                                        typeValue = "jres:33000292" //RC 33000292 : Desetinn� ��slo
                                        openValue = "decimal_value"
                                    } else {
                                        typeValue = "jres:33000296" //RC 33000296 : Textov� hodnota
                                        openValue = "string_value"
                                    }
                                    break;
                                case 10:
                                    editValue = "jres:33000294" //RC 33000294 : V�b�r z pevn�ho ��seln�ku hodnot
                                    openValue = "seznam_value"
                                    break;
                                case 20:
                                    editValue = "jres:33000295" //RC 33000295 : V�b�r z administrovan�ho seznamu hodnot
                                    openValue = "seznam_value"
                                    break;
                            }
                            if (ctx.value.typ_par == 10 || ctx.value.typ_par == 20) {
                                if (ctx.value.priz_multi == 1) {
                                    typeValue = "jres:33000297"; //RC 33000297 : Sou�asn� v�b�r v�ce hodnot
                                    openValue += "_multi";
                                } else {
                                    typeValue = "jres:33000298"; //RC 33000298 : V�b�r pouze jedn� hodnoty
                                }
                            }
                            if (openValue == "password_value") {
                                this.ShowField("password_type")
                                this.ShowField("password_map")
                            } else {
                                this.HideField("password_type")
                                this.HideField("password_map")
                            }
                            if (ctx.value.povol_null != 1 && ctx.value.priz_multi == 0) {
                                if (ctx.value.priz_passwd == 0) {
                                    this.cnt.findFields(openValue).gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })])
                                    this.cnt.findFields(openValue).gfield("option", "flag", "required");
                                }
                            }
                            this.cnt.findFields("type_value").gfield("setValue", typeValue);
                            this.cnt.findFields("povol_edit").gfield("setValue", editValue);
                            this.cnt.findFields("param_popis").gfield("setValue", ctx.value?.popis?.replace(/\\n/g, " "));
                            this.ShowField(openValue);
                            if (this.options.newRecord == true) {
                                this.cnt.findFields(openValue).gfield("enable");
                            }
                            if (openValue == "password_value") {
                                this.cnt.findFields("password_type").gfield(this.editMode == true ? "enable" : "disable")
                                this.cnt.findFields("password_map").gfield(this.editMode == true ? "enable" : "disable")
                                var radioVal = this.cnt.findFields("password_type").gfield("getValue");
                                if (radioVal == 0) {
                                    this.HideField("password_map");
                                } else if (radioVal == 10) {
                                    this.HideField("password_value")
                                    this.HideField("password_map")
                                } else if (radioVal == 20) {
                                    this.HideField("password_value")
                                }
                            }
                            this.currentConfigValue = openValue;
                            this.currentParamInfo = ctx.value;
                        }
                    } else {
                        this.cnt.findFields("type_value").gfield("setValue", "");
                        this.cnt.findFields("povol_edit").gfield("setValue", "");
                        this.cnt.findFields("param_popis").gfield("setValue", "");
                    }
                }
            });
            this.form.addRow().addField("gstaticfield", {
                name: "param_popis"
            })
            this.form.addRow().addField("gstaticfield", {
                name: "type_value"
            })
            this.form.addRow().addField("gstaticfield", {
                name: "povol_edit"
            })
            this.form.addRow()
            // ��seln� hodnota
            this.form.addRow({
                label: "jres:29932124",
                name: "row_number_value"
            }).addField("gnumberbox", {
                name: "number_value",
                disabled: true
            })
            // Desetinn� hodnota
            this.form.addRow({
                label: "jres:29932124",
                name: "row_decimal_value"
            }).addField("gnumberbox", Gordic.Prefabs.Number.decimal(5), {
                name: "decimal_value",
                disabled: true,
                returnType: "number"
            })
            // Textov� hodnota
            this.form.addRow({
                label: "jres:29932124",
                name: "row_string_value"
            }).addField("gstringbox", {
                name: "string_value",
                disabled: true,
            })
            // Heslo
            this.form.addRow({
                label: "jres:33000631",  //RC 33000631 : Zp�sob ulo�en� hesla
                name: "row_password_radio"
            }).addField("gradio", {
                name: "password_type",
                disabled: true,
                initialValue: (this.data.zpusob_ulozeni_hesla) ? this.data.zpusob_ulozeni_hesla : 0,
                itemClass: "w-12",
                radios: [
                    { value: 0, label: "jres:33000632" }, //RC 33000632 : Datab�ze
                    { value: 10, label: "jres:33000633"}, //RC 33000633 : P��m� mapov�n�
                    { value: 20, label: "jres:33000634"} //RC 33000634 : Nep��m� mapov�n�
                ],
                change: (ev, ctx) => {
                    this.HideField("password_map");
                    this.HideField("password_value");
                    if (ctx.value == 0) {
                        this.ShowField("password_value")
                    } else if (ctx.value == 20) {
                        this.ShowField("password_map")
                    }
                },
                model: function (op, model, opt) {
                    switch (op) {
                        case "collect":
                            var returnValue = $(this).gfield("getValue");
                            model.zpusob_ulozeni_hesla = returnValue;
                            break;
                    }
                }
            })
            this.form.addRow({
                label: "jres:33000635", //RC 33000635 : Mapovac� �et�zec
            }).addField("gstringbox", {
                name: "password_map",
                initialValue: (this.data.zpusob_ulozeni_hesla == 20) ? this.data.config : "",
                disabled: true,
                tag: {
                    text: "jres:33000644", //RC 33000644 : Sem nezad�vejte heslo ale pouze informaci, kde je heslo ulo�eno (odkaz, identifik�tor)!
                    state: "warning"
                }
            })
            this.form.addRow({
                label: "jres:29932124",
                name: "row_password_value"
            }).addField("gstringbox", Gordic.Prefabs.GStringBox.password({
                    obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
            }), {
                name: "password_value",
                initialValue: (this.data.zpusob_ulozeni_hesla == 0) ? this.data.config_txt : "",
                disabled: true,
                tag: {
                    text: "jres:33000289", //RC 33000289 : Z bezpe�nostn�ch d�vod� nen� aktu�ln� nastaven� heslo zobrazen�.
                    state: "info"
                }
            })
            // Nab�dka z p�eddefinovan�ho seznamu
            this.form.addRow({
                label: "jres:29932124",
                name: "row_seznam_value"
            }).addField("gselectbox", {
                name: "seznam_value",
                dropdown: true,
                disabled: true,
                itemTemplate: "{config_txt}",
                model: function (op, model, opt) {
                    switch (op) {
                        case "apply":
                            if (model.param_info)
                                if (model.param_info.priz_multi == 0 && (model.param_info.typ_par == 10 || model.param_info.typ_par == 20))
                                    if (model.config && model.config_txt) {
                                        var index = _this.configData.findIndex(obj => obj.config.trim() == model.config.trim());
                                        if (index != -1)
                                            $(this).gfield("setValue", { config: model.config, config_txt: _this.configData[index].config_txt }, { valid: false });
                                        else
                                            $(this).gfield("setValue", { config: "", config_txt: "" }, { valid: false });
                                    }
                            break;
                        case "collect":
                            var returnValue = $(this).gfield("getValue");
                            if (returnValue) {
                                model.seznam_value = { config: "", config_txt: "" };
                                model.seznam_value.config = returnValue.config;
                                model.seznam_value.config_txt = returnValue.config_txt;
                            } else
                                model.seznam_value = null;
                    }
                }
            })
            // Nab�dka z p�eddefinovan�ho seznamu multi 
            this.form.addRow({
                label: "jres:29932124",
                name: "row_seznam_value"
            }).addField("gselectbox", {
                name: "seznam_value_multi",
                dropdown: false,
                disabled: true,
                multi: true,
                itemTemplate: "{config_txt}",
                itemWidth: "",
                model: function (op, model, opt) {
                    switch (op) {
                        case "apply":
                            if (model.param_info) {
                                if (model.param_info.priz_multi == 1 && (model.param_info.typ_par == 10 || model.param_info.typ_par == 20)) {
                                    if (model.config && model.config_txt) {
                                        var configArr = model.config.split(',')
                                        var config_txtArr = model.config_txt.split(',')
                                        var arrayObject = new Array();
                                        for (var i = 0; i < configArr.length; i++) {
                                            var index = _this.configData.findIndex(obj => obj.config == configArr[i])
                                            if (index != -1) {
                                                arrayObject.push({ config: configArr[i], config_txt: _this.configData[index].config_txt })
                                            }
                                        }
                                        $(this).gfield("setValue", arrayObject, { valid: false });
                                    }
                                }
                            }
                            break;
                        case "collect":
                            var returnValue = $(this).gfield("getValue");
                            if (returnValue.length > 0) {
                                model.seznam_value_multi = { config: "", config_txt: "" };
                                returnValue.forEach((item) => {
                                    model.seznam_value_multi.config += item.config + ",";
                                    model.seznam_value_multi.config_txt += item.config_txt + ",";
                                })
                                model.seznam_value_multi.config = model.seznam_value_multi.config.slice(0, -1);
                                model.seznam_value_multi.config_txt = model.seznam_value_multi.config_txt.slice(0, -1);
                            } else 
                                model.seznam_value_multi = null;
                    }
                }
            })
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt(), { model: "model.aktivita=value.aktivita" });
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
            this.MakeField("dat_zmena");
        }

        afterCreatingForm() {
            // Schov�n� pol�
            //if (this.options.newRecord == true) {
                this.HideField("number_value");
                this.HideField("decimal_value");
                this.HideField("string_value");
                this.HideField("password_value");
                this.HideField("password_type");
                this.HideField("password_map");
                this.HideField("seznam_value");
                this.HideField("seznam_value_multi");
            //}
            // Vlo�en� dat
            if (this.options.newRecord == false || this.copy == true) {
                switch (this.data.param_info?.typ_par) {
                    case 0:
                        if (this.data.param_info?.priz_num == 1)
                            this.cnt.findFields("number_value").gfield("setValue", this.data.config)
                        else if (this.data.param_info?.priz_num == 2)
                            this.cnt.findFields("decimal_value").gfield("setValue", this.data.config)
                        else 
                            this.cnt.findFields("string_value").gfield("setValue", this.data.config)
                        break;
                }

                switch (this.data.param_info?.typ_par) {
                    case 0:
                        if (this.data.param_info?.priz_passwd == 1) {
                            var radioVal = this.cnt.findFields("password_type").gfield("getValue");
                            if (radioVal == 0) {
                                this.ShowField("password_value")
                            } else if (radioVal == 20) {
                                this.ShowField("password_map")
                            } 
                        } else if (this.data.param_info?.priz_num == 1) {
                            this.ShowField("number_value");
                        } else if (this.data.param_info?.priz_num == 2) {
                            this.ShowField("decimal_value")
                        } else {
                            this.ShowField("string_value")
                        }
                        break;
                    case 10:
                        this.ShowField("seznam_value")
                        break;
                    case 20:
                        this.ShowField("seznam_value")
                        break;
                }
            }
        }

        private createSubjectField() {
            var _this = this;
            switch (this.uroven_cfg) {
                case 20:
                    this.form.addRow({
                        label: "jres:33000308", //RC 33000308 : Intern� subjekt
                        name: "row_interni_subjekt_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.ekosico(), {
                            itemTemplate: "{ico:trim:encode} - {nazev:trim:encode}",
                            name: "interni_subjekt_value",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: /*(this.options.newRecord == true) ? false : */ true,
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 20) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { ico: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").ico;
                                            break;
                                    }
                                }
                            }
                        })
                    break;
                case 30:
                    this.form.addRow({
                        label: "jres:29930142",
                        name: "row_licence_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.ginslok(), {
                            serverFilters: {
                                aktivita: [100, 300, 500, 600, 900]
                            },
                            itemTemplate: "{lic:trim:encode} - {nazev:trim:encode}",
                            name: "licence_value",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? false : true,
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 30) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { lic: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").lic;
                                            break;
                                    }
                                }
                            }
                        })
                    break;
                case 35:
                    this.form.addRow({
                        label: "jres:29802703",
                        name: "row_stredisko_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.ginstre(), {
                            name: "stredisko_value",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? false : true,
                            change: (ev, ctx) => {
                                //if (this.options.newRecord == true) {
                                //    this.cnt.findFields("type_value").gfield("setValue", "");
                                //    this.cnt.findFields("povol_edit").gfield("setValue", "");
                                //    this.cnt.findFields("param_popis").gfield("setValue", "");
                                //}
                            },
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 35) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { ixs_tre: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").ixs_tre;
                                            break
                                    }
                                }
                            }
                        })
                    break;
                case 38:
                    this.form.addRow({
                        label: "jres:33000005",
                        name: "row_faze_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.gincfaz(), {

                            name: "faze_value",
                            serverFilters: {
                                aktivita: 100
                            },
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? ((this.data.subj_cfg != null && this.data.subj_cfg != undefined) ? true : false) : true,
                            change: (ev, ctx) => {
                                //if (this.options.newRecord == true) {
                                //    this.cnt.findFields("type_value").gfield("setValue", "");
                                //    this.cnt.findFields("povol_edit").gfield("setValue", "");
                                //    this.cnt.findFields("param_popis").gfield("setValue", "");
                                //}
                            },
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 38) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { faze: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").faze;
                                            break
                                    }
                                }
                            }
                        })
                    break;
                case 40:
                    this.form.addRow({
                        label: "jres:29929931",
                        name: "row_instance_value",
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.ginsins(), {
                            name: "instance_value",
                            itemTemplate: "<b>{faze:trim:encode}</b> - {nazev:trim:encode}",
                            graphicInput: "oninput",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? ((this.data.subj_cfg != null && this.data.subj_cfg != undefined) ? true : false) : true,
                            change: (ev, ctx) => {
                                //if (this.options.newRecord == true) {
                                //    this.cnt.findFields("type_value").gfield("setValue", "");
                                //    this.cnt.findFields("povol_edit").gfield("setValue", "");
                                //    this.cnt.findFields("param_popis").gfield("setValue", "");
                                //}
                            },
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 40) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { ixs_ins: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").ixs_ins;
                                            break
                                    }
                                }
                            }
                        })
                    break;
                //case 50:
                //    this.form.addRow({

                //    }).addField("gselectbox", Gordic.Prefabs.Select.)
                case 60:
                    this.form.addRow({
                        label: "jres:32131054",
                        name: "row_funkcni_misto_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.ginsfun(), {
                            name: "funkcni_misto_value",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? ((this.data.subj_cfg != null && this.data.subj_cfg != undefined) ? true : false) : true,
                            change: (ev, ctx) => {
                                //if (this.options.newRecord == true) {
                                //    this.cnt.findFields("type_value").gfield("setValue", "");
                                //    this.cnt.findFields("povol_edit").gfield("setValue", "");
                                //    this.cnt.findFields("param_popis").gfield("setValue", "");
                                //}
                            },
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 60) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { ixs_fun: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").ixs_fun;
                                            break
                                    }
                                }
                            }
                        })
                    break;
                case 70:
                    this.form.addRow({
                        label: "jres:29931718",
                        name: "row_externi_system_value"
                    })
                        .addField("gselectbox", Gordic.Prefabs.Select.intsext(), {
                            serverFilters: {
                                priz_ess: [1, 2, 3],
                                aktivita: 100
                            },
                            name: "externi_system_value",
                            validators: [new Gordic.Validators.Required({ stopping: true })],
                            disabled: (this.options.newRecord == true) ? false : true,
                            change: (ev, ctx) => {
                                //if (this.options.newRecord == true) {
                                //    this.cnt.findFields("type_value").gfield("setValue", "");
                                //    this.cnt.findFields("povol_edit").gfield("setValue", "");
                                //    this.cnt.findFields("param_popis").gfield("setValue", "");
                                //}
                            },
                            model: function (op, dto, opt) {
                                if (_this.uroven_cfg == 70) {
                                    switch (op) {
                                        case "apply":
                                            $(this).gfield("setValue", { ixs_ext: dto.subj_cfg }, { valid: false })
                                            break;
                                        case "collect":
                                            dto.subj_cfg = $(this).gfield("getValue").ixs_ext;
                                            break;
                                    }
                                }
                            }
                        })
                    break;
            }
        }

        private createServerFiltersParam(): any {
            if (this.options.newRecord == true) {
                var serverFilters: any = {};
                serverFilters.uroven_cfg = this.uroven_cfg;
                switch (this.uroven_cfg) {
                    case 40:
                        serverFilters.faze = (this.copy == true) ? null : new Gordic.Forms.Dependency("instance_value", "faze", true, false, this.cnt.element)
                        break;
                    case 30:
                    case 35:
                    case 38:
                    case 60:
                    case 70:
                        serverFilters.faze = "test"
                        break;
                    
                }
                return serverFilters;
            }
            return null;
        }

        private copyParam() {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmParametrGlobal", {
                currentFilter: this.options.currentFilter,
                gridRc: this.options.gridRc
            }], {
                ID: "DetailAdmParametrGlobal",
                newRecord: false,
                copy: true,
                param: this.data.param,
                subj_cfg: this.data.subj_cfg,
                uroven_cfg: this.uroven_cfg,
            })
        }

        //private openTestForm() {
        //    var form = new Gordic.Forms.Form()
        //        .addRow("�et�zec k rozkod�v�n�").addField("gstringbox", {
        //            name: "retezec"
        //        })

        //    this.cnt.dialogs.simpleForm("Testovac� akce", form, {}, {
        //        commandBar: [
        //            {
        //                action: this.cnt.actions.actOk
        //            }
        //        ]
        //    })
        //}

        //private testOk(ev) {
        //    var cnt = $.content(ev.target)
        //    var decodeString = cnt.findFields("retezec").gfield("getValue");
        //    this.getSrv().call("TestDecode", { decodeString: decodeString }).done((result) => {

        //    })
        //}
    }
}